import { CurrencySymbol } from "@repo/components";
import { hasDiscount } from "@repo/lib/utils";
import cx from "classnames";

const PriceCard = ({ price, salePrice, discount, className = "" }) => {
  const discounted = hasDiscount(discount);
  return (
    <div
      className={cx(
        "flex items-center whitespace-nowrap md:mb-0 rtl:justify-end",
        discounted
          ? "mb-3 justify-start gap-2 md:block md:space-x-0 rtl:flex-row-reverse"
          : "",
        className
      )}
    >
      <span
        className={cx(
          "text-price-sale block",
          discounted
            ? "text-sm font-semibold md:ms-auto md:text-xl"
            : "text-lg font-bold"
        )}
      >
        <CurrencySymbol value={discounted ? salePrice : price} />
      </span>

      {discounted && (
        <span className="text-price-regular block text-xs font-medium line-through md:text-base">
          <CurrencySymbol variant="smallSpecial" value={price} />
        </span>
      )}
    </div>
  );
};

const PriceDetailsPage = ({ price, salePrice, discount, className = "" }) => {
  const discounted = hasDiscount(discount);
  return (
    <div
      className={cx(
        "flex items-center whitespace-nowrap",
        discounted ? "justify-start space-x-2 rtl:space-x-reverse" : "",
        className
      )}
    >
      <span className="text-price-sale block text-2xl font-medium md:text-3xl">
        <CurrencySymbol
          variant="mediumRegular"
          value={discounted ? salePrice : price}
        />
      </span>

      {discounted && (
        <span className="text-price-regular block text-xl font-medium line-through">
          <CurrencySymbol variant="mediumSpecial" value={price} />
        </span>
      )}
    </div>
  );
};

const Price = ({ price, salePrice, discount, variant }) => {
  const discounted = hasDiscount(discount);
  const isCart = variant === "cart";

  return (
    <div
      className={cx(
        discounted && isCart && "grid grid-cols-1 whitespace-nowrap"
      )}
    >
      {discounted && (
        <span
          className={cx(
            "text-price-regular flex items-center text-xs font-medium line-through md:text-base",
            isCart && "order-1 text-end md:text-xs"
          )}
        >
          <CurrencySymbol variant="smallSpecial" value={price} />
        </span>
      )}
      <span
        className={cx(
          "text-price-sale flex items-center text-sm font-medium md:text-xl",
          isCart ? "text-end md:text-sm" : "text-start",
          !hasDiscount &&
            "text-price-regular whitespace-nowrap text-2xl font-bold md:text-4xl"
        )}
      >
        <CurrencySymbol
          variant={discounted ? undefined : "smallSpecial"}
          value={discounted ? salePrice : price}
        />
      </span>
    </div>
  );
};

const ProductPrice = ({ price, salePrice, discount, variant, className }) => {
  if (!price) return null;

  const props = { price, salePrice, discount, className };

  switch (variant) {
    case "card":
      return <PriceCard {...props} />;
    case "productDetails":
      return <PriceDetailsPage {...props} />;
    default:
      return <Price {...props} variant={variant} />;
  }
};

export default ProductPrice;
